const normalizeUrl = (value = "") => {
  return String(value).trim().replace(/\/+$/, "");
};

const siteName = process.env.REACT_APP_SITE_NAME?.trim() || "NexRojgar";

const siteUrl = normalizeUrl(
  process.env.REACT_APP_SITE_URL || "https://www.nexrojgar.in",
);

const apiUrl = normalizeUrl(
  process.env.REACT_APP_API_URL || "http://localhost:5000/api",
);

const siteConfig = {
  /* =========================
     Basic branding
  ========================= */

  name: siteName,

  shortName: "NexRojgar",

  logoText: "NexRojgar",

  logoMark: "N",

  storagePrefix: "nexrojgar",

  tagline: "Government Jobs, Results, Admit Cards & Online Services",

  topbarText: "Latest government jobs, results and online service updates",

  navbarTagline: "Government Jobs • Results • Online Services",

  footerTagline: "Government Jobs • Results • Online Services",

  /* =========================
     Website URLs
  ========================= */

  url: siteUrl,

  apiUrl,

  /* =========================
     Default SEO
  ========================= */

  defaultTitle: `${siteName} - Government Jobs, Results, Admit Cards & Online Services`,

  description: `${siteName} provides the latest government jobs, admit cards, results, online services, admissions, scholarships, syllabus updates and official notifications across India.`,

  keywords: [
    "government jobs",
    "sarkari naukri",
    "sarkari result",
    "latest jobs",
    "government vacancy",
    "admit card",
    "results",
    "online services",
    "online apply",
    "aadhaar",
    "pan card",
    "passport",
    "driving licence",
    "voter id",
    "ration card",
    "income certificate",
    "caste certificate",
    "residence certificate",
    "scholarship",
    "admission",
    "syllabus",
  ],

  language: "en-IN",

  locale: "en_IN",

  country: "India",

  /* =========================
     Footer content
  ========================= */

  footerDescription:
    "Latest government jobs, admit cards, results, online services, admissions, scholarships and syllabus updates in one organized place.",
  disclaimerText: `${siteName} is an independent information portal and is not affiliated with any government organization. Always verify information through the official notification or official website.`,

  copyright: `© ${new Date().getFullYear()} ${siteName}. All rights reserved.`,

  /* =========================
     Contact information
  ========================= */

  supportEmail: "support@nexrojgar.in",

  contact: {
    email: "support@nexrojgar.in",

    phone: "",

    address: "",

    workingHours: "Monday to Saturday (10:00 AM - 6:00 PM IST)",
  },

  /* =========================
     Social media
  ========================= */

  social: {
    facebook: "https://www.facebook.com/share/1HkMiVkHfS/",

    instagram: "https://www.instagram.com/abdulspeak2.0?igsh=eXloNnV5MjFoYTht",

    x: "https://x.com/mdabdul_rab",

    youtube: "https://www.youtube.com/@nexrojgar",

    telegram: "",
  },

  /* =========================
     Public assets
  ========================= */

  assets: {
    logo: "/logo192.png",
    favicon: "/favicon.png",
    defaultOgImage: "/og-image.jpg",
    appleTouchIcon: "/logo192.png",
  },

  /* =========================
     Theme information
  ========================= */

  theme: {
    primaryColor: "#800000",

    backgroundColor: "#ffffff",
  },

  /* =========================
     Organization information
  ========================= */

  organization: {
    name: siteName,

    legalName: siteName,

    publisherName: siteName,

    authorName: siteName,

    url: siteUrl,

    email: "support@nexrojgar.in",
  },

  /* =========================
     Routes
  ========================= */

  routes: {
    home: "/",

    about: "/about",

    contact: "/contact",

    privacy: "/privacy-policy",

    disclaimer: "/disclaimer",

    editorialPolicy: "/editorial-policy",

    correctionsPolicy: "/corrections-policy",

    search: "/search",

    login: "/login",

    admin: "/admin",

    adminPosts: "/admin/posts",
  },

  /* =========================
     External services
  ========================= */

  analytics: {
    measurementId: process.env.REACT_APP_GA_MEASUREMENT_ID?.trim() || "",
  },

  adsense: {
    enabled: process.env.REACT_APP_ADSENSE_ENABLED === "true",

    client: process.env.REACT_APP_ADSENSE_CLIENT?.trim() || "",
  },
};

export default siteConfig;
